import {AxiosResponse} from "axios";
import axios from "../utils/axios";
import {
  PropertyFreeTextInfosRequest,
  PropertyFreeTextsInfo,
  PropertyFreeTextsInfosQuery
} from "../models/PropertyFreeTextInfos";

export const fetchPropertyFreeTextInfos = (token: string, propertyId: string) => {
  return new Promise<AxiosResponse<PropertyFreeTextsInfosQuery>>((resolve, reject) => {
    axios
      .get(`${process.env.REACT_APP_API_DOMAIN}/property_free_text_infos/?property=${propertyId}`, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function createPropertyFreeTextInfos(data: PropertyFreeTextInfosRequest, token: string) {
  return new Promise<AxiosResponse<PropertyFreeTextsInfo>>((resolve, reject) => {
    axios
      .post(`${process.env.REACT_APP_API_DOMAIN}/property_free_text_infos/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 201) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function updatePropertyFreeTextInfos(data: PropertyFreeTextInfosRequest, token: string, id: string) {
  return new Promise<AxiosResponse<PropertyFreeTextsInfo>>((resolve, reject) => {
    axios
      .put(`${process.env.REACT_APP_API_DOMAIN}/property_free_text_infos/${id}/`, data, {
        headers: { Authorization: "Token " + token },
      })
      .then((response) => {
        if (response.status === 200) {
          resolve(response);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function deletePropertyFreeTextInfos(id: string, token: string) {
  return new Promise<any>((resolve, reject) => {
    axios
      .delete(`${process.env.REACT_APP_API_DOMAIN}/property_free_text_infos/${id}/`,
        { headers: { 'Authorization': 'Token ' + token } }
      )
      .then((response) => {
        if (response.status === 204) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}